import React from 'react';
import classnames from 'classnames';

import styles from './example-block.module.scss';

interface Props {
  children: React.ReactNode;
  // Determines the background of the example block.
  background: 'blue' | 'violet' | 'image';
  // String or node that will appear underneath example block
  text: React.ReactNode;
  className?: string;
}

const ExampleBlock = ({children, background, text, className = ''}: Props) => {
  // Appease css modules linter
  const backgroundColorClass = {
    blue: styles.blue,
    violet: styles.violet,
    image: styles.image,
  };

  return (
    <div className={classnames(styles.container, className)}>
      <div className={classnames(styles.content, backgroundColorClass[background])}>{children}</div>
      {!!text && <div className={styles.text}>{text}</div>}
    </div>
  );
};

export default ExampleBlock;
